import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Stack, Input, Divider, IconButton } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import Iconify from '../../../fl-components/Iconify';
import EmojiPicker from '../../../fl-components/EmojiPicker';
import { ConvertToBase64 } from '../../../helper/commonHelper';
import { uploadFile } from '../../../service/upload.file.service';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  minHeight: 56,
  display: 'flex',
  position: 'relative',
  alignItems: 'center',
  paddingLeft: theme.spacing(2)
}));

// ----------------------------------------------------------------------

ChatMessageInput.propTypes = {
  disabled: PropTypes.bool,
  onSend: PropTypes.func,
  sendImageMessage: PropTypes.func,
  classDetails: PropTypes.object,
  classId: PropTypes.string
};

export default function ChatMessageInput({
  disabled,
  onSend,
  sendImageMessage,
  classDetails,
  classId
}) {
  const fileInputRef = useRef(null);
  const [message, setMessage] = useState('');
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const currentUser = useSelector((state) => state.auth.currentUser);

  const handleAttach = () => {
    fileInputRef.current?.click();
  };

  const handleKeyUp = (event) => {
    if (event.key === 'Enter') {
      handleSend();
    }
  };

  const handleFileSelection = async (files) => {
    const key = enqueueSnackbar('File Uploading', {
      variant: 'loading',
      persist: true,
      className: 'loading-variant'
    });
    const base64 = await ConvertToBase64(files[0]);
    const fileObj = {
      base64,
      fileType: files[0].type,
      fileName: files[0].name,
      uploadFor: 'chat',
      userId: currentUser.id,
      orgId: classDetails.orgID
    };
    const res = await uploadFile(classId, fileObj);
    if (res) {
      closeSnackbar(key);
      enqueueSnackbar('File Uploaded Successfully', {
        variant: 'success'
      });
      sendImageMessage(res.fileURL, files[0].name, files[0].type);
    } else {
      closeSnackbar(key);
      enqueueSnackbar('Please try again later', {
        variant: 'error'
      });
    }
  };

  const handleSend = () => {
    if (!message) {
      return '';
    }
    if (onSend) {
      onSend(message);
    }
    return setMessage('');
  };

  return (
    <RootStyle>
      <EmojiPicker disabled={disabled} value={message} setValue={setMessage} />

      <Input
        disabled={disabled}
        fullWidth
        sx={{ paddingLeft: '5px' }}
        value={message}
        disableUnderline
        onKeyUp={handleKeyUp}
        onChange={(event) => setMessage(event.target.value)}
        placeholder="Type a message"
        // startAdornment={
        //   <InputAdornment position="start">
        //     <EmojiPicker disabled={disabled} value={message} setValue={setMessage} />
        //   </InputAdornment>
        // }
        endAdornment={
          <Stack direction="row" spacing={1} sx={{ flexShrink: 0, mr: 1.5 }}>
            <IconButton disabled={disabled} size="small" onClick={handleAttach}>
              <Iconify icon="ic:round-add-photo-alternate" width={22} height={22} />
            </IconButton>
            <IconButton disabled={disabled} size="small" onClick={handleAttach}>
              <Iconify icon="eva:attach-2-fill" width={22} height={22} />
            </IconButton>
            {/* <IconButton disabled={disabled} size="small">
              <Iconify icon="eva:mic-fill" width={22} height={22} />
            </IconButton> */}
          </Stack>
        }
      />

      <Divider orientation="vertical" flexItem />

      <IconButton color="primary" disabled={!message} onClick={handleSend} sx={{ mx: 1 }}>
        <Iconify icon="ic:round-send" width={22} height={22} />
      </IconButton>

      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={(e) => handleFileSelection(e.target.files)}
      />
    </RootStyle>
  );
}
